import { fetchdata } from 'apis/FetchData';
import { handle420 } from 'apis/HandleError';

export const fmRequest = (url, options) => {
  const auth = window.__APP_AUTH;
  const headers = {
    Accept: '*/*',
    'cache-control': 'no-cache',
    Authorization: 'Bearer ' + auth?.accessToken,
    'accept-encoding': 'gzip, deflate'
  };

  const requestOptions = {
    headers: headers,
    redirect: 'follow'
  };

  return fetchdata(url, { ...options, ...requestOptions }).catch((e) => {
    console.log('fetch data error = ' + e.message);
    switch (e.message) {
      case '420':
        handle420();
        break;
      default:
        throw e.message;
    }
  });
};
